import React from "react";
// import { Redirect } from "react-router-dom";

// const errorRoute = [
//   {
//     component: () => <Redirect to="/404" />,
//   },
// ];

export const rootRoutes = [
  {
    path: "/consent-form",
    exact: true,
    component: React.lazy(() => import("./views/Consent")),
  },
  {
    path: "/scenerio",
    exact: true,
    component: React.lazy(() => import("./views/Mock")),
  },
  {
    path: "/case-1",
    exact: true,
    component: React.lazy(() => import("./views/Tool1")),
  },
  {
    path: "/case-2",
    exact: true,
    component: React.lazy(() => import("./views/Tool2")),
  },
  {
    path: "/case-3",
    exact: true,
    component: React.lazy(() => import("./views/Tool3")),
  },

  {
    path: "/case-4",
    exact: true,
    component: React.lazy(() => import("./views/Tool4")),
  },
  {
    path: "/case-5",
    exact: true,
    component: React.lazy(() => import("./views/Tool5")),
  },
  {
    path: "/case-6",
    exact: true,
    component: React.lazy(() => import("./views/Tool6")),
  },
  {
    path: "/case-7",
    exact: true,
    component: React.lazy(() => import("./views/Tool7")),
  },
  {
    path: "/case-8",
    exact: true,
    component: React.lazy(() => import("./views/Tool8")),
  },
  {
    path: "/survey-1",
    exact: true,
    component: React.lazy(() => import("./views/SurveyMock1")),
  },
  {
    path: "/survey-2",
    exact: true,
    component: React.lazy(() => import("./views/SurveyMock2")),
  },
  {
    path: "/survey-3",
    exact: true,
    component: React.lazy(() => import("./views/SurveyMock3")),
  },
  {
    path: "/think-aloud-protocol",
    exact: true,
    component: React.lazy(() => import("./views/ThinkAloud")),
  },
  {
    path: "/exp1",
    exact: true,
    component: React.lazy(() => import("./views/Exp1")),
  },
  {
    path: "/exp2",
    exact: true,
    component: React.lazy(() => import("./views/Exp2")),
  },
  {
    path: "/exp3",
    exact: true,
    component: React.lazy(() => import("./views/Exp3")),
  },
  {
    path: "/survey",
    exact: true,
    component: React.lazy(() => import("./views/SurveyPage")),
  },
  {
    path: "/survey-1",
    exact: true,
    component: React.lazy(() => import("./views/SurveyPage1")),
  },
  {
    path: "/survey-2",
    exact: true,
    component: React.lazy(() => import("./views/SurveyPage2")),
  },
  {
    path: "/survey-3",
    exact: true,
    component: React.lazy(() => import("./views/SurveyPage3")),
  },
  {
    path: "/survey-5",
    exact: true,
    component: React.lazy(() => import("./views/SurveyPage5")),
  },
  {
    path: "/survey-6",
    exact: true,
    component: React.lazy(() => import("./views/SurveyPage6")),
  },
  {
    path: "/thank-you",
    exact: true,
    component: React.lazy(() => import("./views/ThankYou")),
  },
  {
    path: "/settings",
    exact: true,
    component: React.lazy(() => import("./views/Settings")),
  },
  {
    path: "/",
    exact: true,
    component: React.lazy(() => import("./views/Welcome")),
  },
  // {
  //   path: "/admin-web-study",
  //   exact: true,
  //   component: React.lazy(() => import("./views/Admin")),
  // },
  // {
  //   path: "/login",
  //   exact: true,
  //   component: React.lazy(() => import("./views/Login")),
  // },
  // {
  //   path: "/requests",
  //   exact: true,
  //   component: React.lazy(() => import("./views/RequestList")),
  // },
  // ...errorRoute,
];
